"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactIntl = require("react-intl");
var _facebookShareButton = _interopRequireDefault(require("./facebook-share-button"));
var _twitterShareButton = _interopRequireDefault(require("./twitter-share-button"));
var _whatsappShareButton = _interopRequireDefault(require("./whatsapp-share-button"));
// import checkMarkImage from './'

const TellAFriend = _ref => {
  let preview = _ref.preview,
    href = _ref.href,
    message = _ref.message,
    twitterShareText = _ref.mobilization.twitter_share_text,
    imageUrl = _ref.imageUrl,
    imageWidth = _ref.imageWidth,
    widget = _ref.widget;
  const settings = widget.settings || {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "center p3 bg-white darkengray rounded"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "m0 h3 bold"
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: "py2"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imageUrl || './check-mark-image.png',
    style: {
      width: imageWidth || 100
    },
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: widget.settings.finish_message_type === 'donation-recurrent' ? 'widgets.components--donation.finish-post-donation-messages.tell-a-friend.text' : 'share.components--tell-a-friend.text',
    defaultMessage: "Agora, compartilhe com seus amigos!"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_facebookShareButton.default, {
    href: href
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_twitterShareButton.default, {
    href: href,
    text: twitterShareText
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_whatsappShareButton.default, {
    whatsappText: settings.whatsapp_text || href
  })));
};
var _default = exports.default = TellAFriend;